// SMS & Calls — the live page payload (KPIs + missed calls + last 20
// SMS) plus the "send SMS" convenience (which dispatches through the
// canonical IP Phone Gateway `send_sms` action — there's no separate
// SMS-send endpoint).

import type { ApiClient } from "./client.js";
import type { IPPhoneRunResult, SmsMainResponse, SmsPageData } from "./types.js";

export function makeSmsApi(client: ApiClient) {
  return {
    /** The SMS & Calls page payload. Throws if the `data` envelope is malformed. */
    async main(): Promise<SmsPageData> {
      const r = await client.get<SmsMainResponse>("/v1/api/sms/main");
      if (!r.ok || !r.data) throw new Error(r.error ?? "sms data unavailable");
      return r.data;
    },
    /** Send an SMS via the Dinstar GSM gateway (the IP Phone gateway's
     *  `send_sms` action — routes to the lowest-priority gateway that
     *  supports it). `number` accepts `01XXXXXXXXX` / `+880…` / a saved
     *  contact's number; the gateway normalises. */
    send(number: string, text: string) {
      return client.post<IPPhoneRunResult>("/v1/api/ipphone/run", {
        action: "send_sms",
        args: { number, text },
      });
    },
  };
}

export type SmsApi = ReturnType<typeof makeSmsApi>;
